<template>
    <section>
        <b-modal :active.sync="showLoginModal"
        		has-modal-card
            	trap-focus
                aria-role="dialog"
                aria-modal
                scroll="keep">
            <div>
    		<form action="">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Login</p>
                    </header>
                    <div v-if="!forgot_password">
                        <section class="modal-card-body">
                            <b-field label="Email">
                                <b-input
                                    v-model="email"
                                    placeholder="Your email"
                                    required>
                                </b-input>
                            </b-field>

                            <b-field label="Password">
                                <b-input
                                    type="password"
                                    v-model="password"
                                    password-reveal
                                    placeholder="Your password"
                                    required>
                                </b-input>
                            </b-field>

                            <a @click="forgotPassword">
                                Forgot password?
                            </a>
                        </section>
                    </div>
                    <div v-if="forgot_password">
                        <section class="modal-card-body">
                            <b-field label="Email">
                                <b-input
                                    v-model="email"
                                    placeholder="Your email"
                                    required>
                                </b-input>
                            </b-field>

                            <b-field label="New password">
                                <b-input
                                    type="password"
                                    v-model="new_password"
                                    password-reveal
                                    placeholder="Your new password"
                                    required>
                                </b-input>
                            </b-field>

                            <b-field label="Confirmation code">
                                <b-input
                                    v-model="code"
                                    placeholder="Your code"
                                    required>
                                </b-input>
                            </b-field>
                        </section>
                    </div>

                    <footer class="modal-card-foot">
                        <button v-if="!forgot_password" class="button is-primary is-fullwidth" type="button" @click="signIn">Login</button>
                        <button v-if="forgot_password" class="button is-primary is-fullwidth" type="button" @click="forgotPasswordSubmit">Send</button>
                    </footer>
                </div>
            </form>
        </div> 
    	</b-modal>
    </section>
</template>


<script>
    import { Auth } from 'aws-amplify'

	export default {
		name: 'LoginModal',

        computed: {
            showLoginModal: {
                get() {
                    return this.$store.getters.showLoginModal
                },
                set() {
                    this.$store.commit('toggleLoginModal')
                    this.forgot_password = false
                }
            }
        },

        methods: {
            changeLoginModalState () {
                this.$store.commit('toggleLoginModal')
            },

            signIn () {
                Auth.signIn(this.email, this.password)
                .then(user => {
                    this.axios
                        .get(this.$store.state.apiUrl + '/get_user/' + user.username)
                        .then(data => {
                            console.log(data.data.credits)
                            this.$store.state.credits = data.data.credits
                        })
                        .catch(err => {
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: err.message,
                                type: 'is-danger',
                                hasIcon: true
                            })
                        })
                    this.$store.state.user = user
                    this.$store.state.signedIn = !!user

                    this.email = null
                    this.password = null        
                    this.changeLoginModalState()
                })
                .catch(err => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: err.message,
                        type: 'is-danger',
                        hasIcon: true
                    })
                })
            },

            forgotPassword () {
                Auth.forgotPassword(this.email)
                .then(data => {
                    this.$buefy.dialog.alert('An email with a confirmation code has been sent to ' + this.email)
                    this.forgot_password = true
                })
                .catch(err => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: err.message,
                        type: 'is-danger',
                        hasIcon: true
                    })
                })
            },

            forgotPasswordSubmit () {
                Auth.forgotPasswordSubmit(this.email, this.code, this.new_password)
                .then(data => {
                    this.$buefy.dialog.alert('Your password has been reset')
                    this.forgot_password = false
                    this.password = null
                    this.new_password = null
                })
                .catch(err => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: err.message,
                        type: 'is-danger',
                        hasIcon: true
                    })
                })
            }
        },

		data() {
			return {
				email: null,
                password: null,
                new_password: null,
                forgot_password: false,
                code: null
			}
		}
	}
</script>